/**
 * @module playerManager
 * @private
 */

// TODO Move to config
const languagesMap = {
  eng: "en",
  english: "en",
  ara: "ar",
  arabic: "ar",
  fra: "fr",
  french: "fr",
  tur: "tr",
  turkish: "tr"
};

const originalLanguagesMap = {
  en: "eng",
  ar: "ara",
  fr: "fra",
  tr: "tur"
};

/**
 * Ensures that the returned track contains always the same convention for the language property. The tracks can come
 * with different values for the same language. For example, english tracks can have 'en' or 'eng' value in the language
 * property. This function returns always the 2 character version of the language.
 * @param {string} language The language property present in the video player track
 * @returns {string} The 2 character language code of the found language or the language as it was received if there was
 * no translation found.
 */
export function normalizeLanguage(language) {
  return languagesMap[language] || language;
}

/**
 * Returns original version of the language (version that webmaf returns on getAudioTracks event).
 * @param {string} language The normalized language property
 * @returns {string} The original language code
 */
export function getOriginalLanguage(language) {
  return originalLanguagesMap[language] || language;
}
